import { CircularProgress } from '@mui/material'
import { isNilOrEmpty } from 'ramda-adjunct'
import { map } from 'ramda'
import { Redirect, Route, Switch } from 'react-router-dom'
import { useSelector } from 'react-redux'
import React, { lazy, Suspense } from 'react'

import Layout from 'core/Layout'
import routes, { getPagePath } from 'config/routes'
import STORE_NAMESPACES from 'store/namespaces'

import useStyles from './styles'

const Router = () => {
  const classes = useStyles()
  const { token } = useSelector(state => state[STORE_NAMESPACES.SECURITY])

  return (
    <Layout>
      <Suspense
        fallback={
          <div className={classes.progress}>
            <CircularProgress />
          </div>
        }
      >
        <Switch>
          {map(
            ({
              id,
              feature,
              props: pageProps = {},
              isAuthenticationRequired,
              ...routeProps
            }) => {
              const PageComponent = lazy(() => import(`features/${feature}`))

              return (
                <Route
                  {...routeProps}
                  render={() => {
                    if (isAuthenticationRequired && isNilOrEmpty(token)) {
                      return <Redirect to={getPagePath('login')} />
                    }

                    return <PageComponent {...pageProps} />
                  }}
                  key={`page-${id}`}
                />
              )
            },
            routes,
          )}
          {/* keep this line at the bottom to keep the 404 mechanism working */}
          <Route
            render={() => (
              <Redirect
                to={{
                  pathname: getPagePath('notFound'),
                  state: { status: 404 },
                }}
              />
            )}
            key="redirect-notFound"
          />
        </Switch>
      </Suspense>
    </Layout>
  )
}

export default Router
